import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  analyticsProlongCircuitReportAvailability,
  DownloadLink2,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useProlongCircuitReportLink = (
  options: UseMutationOptions<
    DownloadLink2,
    unknown,
    { year: number; quarter: number; circuitId: number },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: { year: number; quarter: number; circuitId: number }) =>
      extractData(analyticsProlongCircuitReportAvailability({ path: args })),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: [
          'Analytics',
          'CircuitReports',
          variables.year,
          variables.quarter,
        ],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
